/* eslint-disable valid-jsdoc */
/* eslint-disable camelcase */
import Configuration from "../key-configuration/configuration.json5";

export default class SurveyLink {
  /**
   * @param {string} URL
   * @returns link
   * replace {AND} with &
   */
  static HandleAmpercend(value) {
    return value.toString().replace(/{AND}/g, "&");
  }

  /**
   * @param {string} _page only claim overview page sends survey request, reserved parameter
   * @param {string} lang
   * @returns link
   */
  static getLink(_page, lang) {
    const surveyUrlEn = _page === 'DI6' ? Configuration.surveyLinkDI6.en : Configuration.surveyLinkClaim.en;
    const surveyUrlFr = _page === 'DI6' ? Configuration.surveyLinkDI6.fr : Configuration.surveyLinkClaim.fr;
    if (lang === "fr") {
      return this.HandleAmpercend(surveyUrlFr);
    }
    return this.HandleAmpercend(surveyUrlEn);
  }

  /**
   * @param {string} page
   * @param {string} lang
   * @returns content
   */
  static surveyLink_calimOverview_En(page, lang) {
    if (lang === "fr") {
      return `<!DOCTYPE html>
<html lang="fr">
    <head>
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <meta charset="utf-8">
        <link href="https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,200..1000;1,200..1000&display=swap" rel="stylesheet">
        <meta http-equiv="X-UA-Compatible" content="IE=edge"> 
        <style>
        body {
            font-family: "Mulish", sans-serif;
            font-size:16px;
        }
        
        /* The Modal (background) */
        .modal-survey {
          display: none; /* Hidden by default */
          position: fixed; /* Stay in place */
          z-index: 99; /* Sit on top */
          left: 0;
          top: 0;
          width: 100%; 
          height: 100%;
          overflow: auto; /* Enable scroll if needed */
          background-color: rgb(0,0,0); /* Fallback color */
          background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
        }
        
        /* Modal Content */
        .modal-content {
          margin: auto;
          padding: 24px;
          background-color: #003359;
          color: white;
          width: 500px;
            /*height: 500px; customization - remove vertical scroll bar*/
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          box-sizing: content-box;
          overflow-y:auto;
          border-radius: 10px;
          text-align:center;
        }
        
        .modal-content:focus {
            outline: none;
        }
        
        /* Close (X) button */
        .x-button-container {
            display: flex;
            justify-content:flex-end;
        }
        .DistributionPopUpXButton {
            width: 32px;
              height: 32px;
        }
        /* Logo */
        .logo-container {
            display: flex;
            justify-content:center;
            align-items: center;
            gap:32px;
            height:42px;
            margin: 24px 0;
        }
        img#WSIBLogo {
            height:42px;
        }
        img#ForumResearchLogo {
            height:42px;
        }
        
        /* Title */
        .DistributionPopUpTitle {
            margin: 0;
            font-weight: 500;
            color: white !important; /*customization - set title color to white*/
            font-size: 32px !important;
            padding: 0px !important;
        }
        
        /* Paragraphs */
        .DistributionPopUpText {
            margin: 24px 0;
            font-size:1.15em;
            font-weight:300
        }
        .DistributionPopUpText2 {
            margin: 24px 0;
            font-weight: 100;
        }
        
        /* Buttons */
        .DistributionPopUpButton {
            transition:all 0.1s;
	        background-color: white;
	        color: #003359;
            border-radius: 48px;
	        padding: 0.85em 1.625em;
            font-size: 17.6px !important;
	        font-weight: 700;
	        width: fit-content;
	        height: 48 px;
	        gap: 10px;
            margin: 0 auto
        }
        .DistributionPopUpButton2 {
            transition:all 0.2s;
            color: white;
            border-radius: 100px;
            margin: 16px 0;
            font-size:1.1em;
            font-weight: 300;
            text-decoration: 1px underline;
            text-underline-offset: 2px;
        }
        
        .DistributionPopUpButton:hover, a:focus .DistributionPopUpButton, a:active .DistributionPopUpButton {
            background-color: #0D73B8;
            color: white;
        }
        
        a.DistributionPopUpLink {
            text-decoration: none;
        }
        
        
        /* Mobile styles - landscape */
        @media (max-width: 932px) and (max-height: 524px) and (orientation: landscape) {
            .modal-content {
                height: calc(100% - 24px);
                width: calc(100% - 24px);
                box-sizing:border-box;
                font-size:0.85em;
            }
        
        
            img#WSIBLogo {
                height:38px;
            }
            img#ForumResearchLogo {
                height:38px;
            }
            
        }

        /* Mobile styles - portrait */
        @media (max-width: 524px) {
            /* Modal Content */
            .modal-content {
                margin: auto;
                padding: 16px;
                width: 100%;
                height: 100%;
                box-sizing:border-box;
            }
            /* Logo */
            .logo-container {
                display: flex;
                justify-content:center;
                align-items: center;
                height:38px;
                margin: 20px 0;
            }
            img#WSIBLogo {
                height:38px;
            }
            img#ForumResearchLogo {
                height:38px;
            }
            
            /* Title */
            .DistributionPopUpTitle {
                margin:0;
                font-weight: 500;
                color: white !important; /*customization - set title color to white*/
                font-size: 32px !important;
                padding: 0px !important;
            }
            
            /* Paragraphs */
            .DistributionPopUpText {
                margin: 16px 0;
                font-size:1.15em;
                font-weight:300
            }
        
        
            /* Buttons */
            .DistributionPopUpButton {
                border-radius: 48px;
                font-size:1.1em;
                font-weight: 700;
            }
            .DistributionPopUpButton2 {
                transition:all 0.2s;
                color: white;
                border-radius: 100px;
                font-size:1.1em;
                font-weight: 300;
                text-decoration: 1px underline;
                text-underline-offset: 2px;
            }
        
            .DistributionPopUpText2 {
                font-size:0.85em;
                margin: 16px 0;
            }
        }
        /* Mobile styles - extra small */
        @media (max-width: 240px) {    
            .modal-content {
                font-size: 0.75em;
                padding:8px;
            }
            .logo-container{
                display:none;
            }
        }
        
        </style>
        </head>
<body>

<!-- The Modal -->
<div id="myModal" class="modal-survey">

    <!-- Modal content -->
    <div class="modal-content" role="dialog" tabindex="-1" aria-modal="true" aria-label="Parlez-nous de votre expérience!">
        <div class="x-button-container">
            <a href="javascript:void(0);" onclick='
                var modal = document.getElementById("myModal");
                var modalOpen = false;
                modalOpen = false;
                modal.style.display = "none";'
                aria-label="Fermer" id="DistributionPopUpXButtonLink">
                <div class="DistributionPopUpXButton" onclick='
                    var modal = document.getElementById("myModal");
                    var modalOpen = false;
                    modalOpen = false;
                    modal.style.display = "none";'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M7 7L17 17M7 17L17 7" stroke="#fff" stroke-width="1" stroke-linecap="round"/>
                    </svg>                
                </div>
            </a>
        </div>
        <div class="logo-container">
            <div aria-label="Workplace Safety and Insurance Board"><img src="/branding/wsib_logo_white.svg" alt="Workplace Safety and Insurance Board" aria-hidden="true" id="WSIBLogo"></div>
            <div aria-label="Forum Research"><img src="/branding/forum_logo_white.svg" alt="Forum Research" aria-hidden="true" id="ForumResearchLogo"></div>
        </div>
        <h1 class="DistributionPopUpTitle">Parlez-nous de votre expérience!</h1>
        <p class="DistributionPopUpText">Merci d’avoir utilisé nos services en ligne. Vous avez été choisi(e) pour participer à un court sondage sur la satisfaction. Veuillez le compléter à la fin de votre session.</p>
        <a href="${this.getLink(
                page,
                lang
            )}" target="_blank" onclick='
            var modal = document.getElementById("myModal");
            // Is modal currently open?
            var modalOpen = false;
            modalOpen = false;
            modal.style.display = "none";' class="DistributionPopUpLink" id="DistributionPopUpYes" title="Le lien de rétroaction s’ouvre dans un nouvel onglet" aria-label="Le lien de rétroaction s’ouvre dans un nouvel onglet">
            <div class="DistributionPopUpButton">Oui, je vais donner mon avis à la fin de ma session</div>
        </a>
        <a href="javascript:void(0);" onclick='
			var modal = document.getElementById("myModal");
			// Is modal currently open?
			var modalOpen = false;
			modalOpen = false;
			modal.style.display = "none";' class="DistributionPopUpLink" id="DistributionPopUpNo">
            <div class="DistributionPopUpButton2">Non merci</div>
        </a>
        <p class="DistributionPopUpText2">Forum Research, une entreprise indépendante, mène ce sondage au nom de la Commission de la sécurité professionnelle et de l’assurance contre les accidents du travail (WSIB).</p>
    </div>
</div>

<script>
// Get the modal
const modal = document.getElementById("myModal");
// Is modal currently open?
let modalOpen = false;

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
    if (event.target === modal) {
        declinesurvey();
    }
}

// Show modal popup
function showsurvey() {
    modalOpen = true;
    modal.style.display = "block";
    // Focus on modal content
    document.getElementsByClassName("modal-content")[0].focus();
}

// Accept survey
function acceptsurvey() {
    hidesurvey();
}

// Decline survey
function declinesurvey() {
    hidesurvey();
}

// Hide modal popup
function hidesurvey() {
    modalOpen = false;
    modal.style.display = "none";
}

// Probability of being asked to do the survey (must be between 0 and 1)
const surveyprobability = 0.5;

// Randomly show popup to surveyprobability % of respondents if cookie is not set
function randomsurvey() {
    let cookie = document.cookie.match(new RegExp('Acuity4PopUp=([^;]+)'));
    let random = Math.random();
    if (!cookie && random < surveyprobability) {
        showsurvey();
        // Set cookie so popup does not show up again. Set to be 2,592,000‬ seconds (30 days)
        document.cookie='Acuity4PopUp=true; path=/; max-age=2592000';
    }
}

// Randomly show modal popup when document is ready
document.addEventListener("DOMContentLoaded", function(event) {
  randomsurvey();
});

document.addEventListener("keydown", function(event) {
    if (modalOpen === true) {
        switch (event.keyCode) {
            case 9: // Tab
                if (event.shiftKey) { // Backward tab (shift-tab) - go from first element of popup to last element of popup
                    if (document.activeElement === document.getElementById("DistributionPopUpXButtonLink") || document.activeElement === document.getElementsByClassName("modal-content")[0]) {
                        event.preventDefault();
                        document.getElementById("DistributionPopUpNo").focus();
                    }
                } else { // Forward tab - go from last element of popup to first element of popup
                    if (document.activeElement === document.getElementById("DistributionPopUpNo")) {
                        event.preventDefault();
                        document.getElementById("DistributionPopUpXButtonLink").focus();
                    }
                }
                break;
            case 27: // Escape
                // Hide popup window when escape is pressed
                declinesurvey();
                break;
        }
    }
});
</script>

</body>
</html>
            `;
    }
    return `
<!DOCTYPE html>
<html lang="en">
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
<meta charset="utf-8">
<link href="https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap" rel="stylesheet">
<meta http-equiv="X-UA-Compatible" content="IE=edge"> 
<style>
body {
    font-family: "Mulish", sans-serif;
    font-size:16px;
}

/* The Modal (background) */
.modal-survey {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 99; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%;
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  margin: auto;
  padding: 24px;
  background-color: #003359;
  color: white;
  width: 500px;
  /*height: 500px; customization - remove vertical scroll bar*/
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: content-box;
  overflow-y:auto;
  border-radius: 10px;
  text-align:center;
}


.modal-content:focus {
    outline: none;
}

/* Close (X) button */
.x-button-container {
    display: flex;
    justify-content:flex-end;
}
.DistributionPopUpXButton {
    width: 32px;
      height: 32px;
}
/* Logo */
.logo-container {
    display: flex;
    justify-content:center;
    align-items: center;
    gap:32px;
    height:42px;
    margin: 24px 0;
}
img#WSIBLogo {
    height:42px;
}
img#ForumResearchLogo {
    height:42px;
}

/* Title */

.DistributionPopUpTitle {
    margin:0;
    font-weight: 500;
    color: white !important; /*customization - set title color to white*/
    font-size: 32px !important;
    padding: 0px !important;
}

/* Paragraphs */
.DistributionPopUpText {
    margin: 1.5em 0;
    font-size:1.15em;
    font-weight:300
}
.DistributionPopUpText2 {
    margin: 1.5em 0;
    font-weight: 100;
}



/* Buttons */
.DistributionPopUpButton {
    transition:all 0.1s;
	background-color: white;
	color: #003359;
    border-radius: 48px;
	padding: 0.85em 1.625em;
    font-size: 17.6px !important;
	font-weight: 700;
	width: fit-content;
	height: 48 px;
	gap: 10px;
    margin: 0 auto
}
.DistributionPopUpButton2 {
    transition:all 0.2s;
    color: white;
    border-radius: 100px;
    margin: 16px 0;
    font-size:1.1em;
    font-weight: 300;
    text-decoration: 1px underline;
    text-underline-offset: 2px;
}

.DistributionPopUpButton:hover, a:focus .DistributionPopUpButton, a:active .DistributionPopUpButton {
    background-color: #0D73B8;
    color: white;
}

a.DistributionPopUpLink {
    text-decoration: none;
}


/* Mobile styles - landscape */
@media (max-width: 932px) and (max-height: 524px) and (orientation: landscape) {
    .modal-content {
        height: calc(100% - 24px);
        width: calc(100% - 24px);
        box-sizing:border-box;
        font-size:0.85em;
    }


    img#WSIBLogo {
        height:38px;
    }
    img#ForumResearchLogo {
        height:38px;
    }
    
}


/* Mobile styles - portrait */
@media (max-width: 524px) {
    /* Modal Content */
    .modal-content {
        margin: auto;
        padding: 16px;
        width: 100%;
        height: 100%;
        box-sizing:border-box;
    }
    /* Logo */
    .logo-container {
        display: flex;
        justify-content:center;
        align-items: center;
        height:38px;
        margin: 20px 0;
    }
    img#WSIBLogo {
        height:38px;
    }
    img#ForumResearchLogo {
        height:38px;
    }
    
    /* Title */
    .DistributionPopUpTitle {
        margin:0;
        font-weight: 500;
        color: white !important; /*customization - set title color to white*/
        font-size: 32px !important;
        padding: 0px !important;
    }
    
    /* Paragraphs */
    .DistributionPopUpText {
        margin: 16px 0;
        font-size:1.15em;
        font-weight:300
    }


    /* Buttons */
    .DistributionPopUpButton {
        border-radius: 48px;
        font-size:1.1em;
        font-weight: 700;
    }
    .DistributionPopUpButton2 {
        transition:all 0.2s;
        color: white;
        border-radius: 100px;
        font-size:1.1em;
        font-weight: 300;
        text-decoration: 1px underline;
        text-underline-offset: 2px;
    }

    .DistributionPopUpText2 {
        font-size:0.85em;
        margin: 16px 0;
    }
}
/* Mobile styles - extra small */
@media (max-width: 240px) {    
    .modal-content {
        font-size: 0.75em;
        padding:8px;
    }
    .logo-container{
        display:none;
    }
}

</style>
</head>
<body>

<!-- The Modal -->
<div id="myModal" class="modal-survey">
    
    <!-- Modal content -->
    <div class="modal-content" role="dialog" tabindex="-1" aria-modal="true" aria-label="Tell us about your experience!">
        <div class="x-button-container">
            <a href="javascript:void(0);" onclick='
                var modal = document.getElementById("myModal");
                var modalOpen = false;
                modalOpen = false;
                modal.style.display = "none";'
                aria-label="Close" id="DistributionPopUpXButtonLink">
                <div class="DistributionPopUpXButton" onclick='
                    var modal = document.getElementById("myModal");
                    var modalOpen = false;
                    modalOpen = false;
                    modal.style.display = "none";'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M7 7L17 17M7 17L17 7" stroke="#fff" stroke-width="1" stroke-linecap="round"/>
                    </svg>
                </div>
            </a>
        </div>

        <div class="logo-container">
            <div aria-label="Workplace Safety and Insurance Board"><img src="/branding/wsib_logo_white.svg" alt="Workplace Safety and Insurance Board" aria-hidden="true" id="WSIBLogo"></div>
            <div aria-label="Forum Research"><img src="/branding/forum_logo_white.svg" alt="Forum Research" aria-hidden="true" id="ForumResearchLogo"></div>
        </div>
        <h1 class="DistributionPopUpTitle">Tell us about your experience!</h1>
        <p class="DistributionPopUpText">Thank you for using our online services. You have been selected to participate in a short satisfaction survey. Please complete it at the end of your session.</p>
        <a href="${this.getLink(
                page,
                lang
            )}" target="_blank" onclick='
            var modal = document.getElementById("myModal");
            // Is modal currently open?
            var modalOpen = false;
            modalOpen = false;
            modal.style.display = "none";' class="DistributionPopUpLink" id="DistributionPopUpYes" title="Feedback link opens in a new tab" aria-label="Feedback link opens in a new tab">
            <div class="DistributionPopUpButton">Yes, I'll give feedback at the end of my session</div>
        </a>
        <a href="javascript:void(0);" onclick='
			var modal = document.getElementById("myModal");
			// Is modal currently open?
			var modalOpen = false;
			modalOpen = false;
			modal.style.display = "none";' class="DistributionPopUpLink" id="DistributionPopUpNo">
            <div class="DistributionPopUpButton2">No, thanks</div>
        </a>
        <p class="DistributionPopUpText2">Forum Research, an independent company, runs this survey on behalf of the WSIB.</p>
    </div>
</div>

<script>
// Get the modal
const modal = document.getElementById("myModal");
// Is modal currently open?
let modalOpen = false;

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
    if (event.target === modal) {
        declinesurvey();
    }
}

// Show modal popup
function showsurvey() {
    modalOpen = true;
    modal.style.display = "block";
    // Focus on modal content
    document.getElementsByClassName("modal-content")[0].focus();
}

// Accept survey
function acceptsurvey() {
    hidesurvey();
}

// Decline survey
function declinesurvey() {
    hidesurvey();
}

// Hide modal popup
function hidesurvey() {
    modalOpen = false;
    modal.style.display = "none";
}

// Probability of being asked to do the survey (must be between 0 and 1)
const surveyprobability = 0.5;

// Randomly show popup to surveyprobability % of respondents if cookie is not set
function randomsurvey() {
    var cookie = document.cookie.match(new RegExp('Acuity4PopUp=([^;]+)'));
    var random = Math.random();
    if (!cookie && random < surveyprobability) {
        showsurvey();
        // Set cookie so popup does not show up again. Set to be 2,592,000‬ seconds (30 days)
        document.cookie='Acuity4PopUp=true; path=/; max-age=2592000';
    }
}

// Randomly show modal popup when document is ready
document.addEventListener("DOMContentLoaded", function(event) { 
  randomsurvey();
 });

document.addEventListener("keydown", function(event) {
    if (modalOpen === true) {
        switch (event.keyCode) {
            case 9: // Tab
                if (event.shiftKey) { // Backward tab (shift-tab) - go from first element of popup to last element of popup
                    if (document.activeElement === document.getElementById("DistributionPopUpXButtonLink") || document.activeElement === document.getElementsByClassName("modal-content")[0]) {
                        event.preventDefault();
                        document.getElementById("DistributionPopUpNo").focus();
                    }
                } else { // Forward tab - go from last element of popup to first element of popup
                    if (document.activeElement === document.getElementById("DistributionPopUpNo")) {
                        event.preventDefault();
                        document.getElementById("DistributionPopUpXButtonLink").focus();
                    }
                }
                break;
            case 27: // Escape
                // Hide popup window when escape is pressed
                declinesurvey();
                break;
        }
    }
});
</script>

</body>
</html>
    `;
  }
}
